var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"JoszakiHtmlTextBlock",domProps:{"innerHTML":_vm._s(_vm.processedHtml)}})
}
var staticRenderFns = []

export { render, staticRenderFns }